import { render, staticRenderFns } from "./gc-status-chip.vue?vue&type=template&id=2f9aa0b0&scoped=true"
import script from "./gc-status-chip.vue?vue&type=script&lang=js"
export * from "./gc-status-chip.vue?vue&type=script&lang=js"
import style0 from "./gc-status-chip.vue?vue&type=style&index=0&id=2f9aa0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9aa0b0",
  null
  
)

export default component.exports